export default __webpack_public_path__ + "static/media/Jump (6).b0a8e0bc.png";